<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('notes')">Notizen</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span> Erschaffen
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.client_id" :error="form.errors.client_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Kunde">
            <option
              v-for="(client, index) in clients"
              :key="index"
              :value="client.id"
              :selected="form.client_id === client.id"
            >
              {{ client.first_name + ' ' + client.last_name }}
            </option>
          </select-input>
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <textarea-input v-model="form.content" :error="form.errors.content" class="pr-6 pb-8 w-full lg:w-full" label="Text" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-green" type="submit">Speichern</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '../../Shared/TextareaInput'
import SelectInput from '../../Shared/SelectInput'


export default {
  metaInfo: { title: 'Notiz Erschaffen' },
  components: {
    SelectInput,
    TextareaInput,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  props: {
    clients: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        content: null,
        client_id: null,
      }),
    }
  },
  created() {
    if (localStorage.getItem('client_id')) {
      this.form.client_id = localStorage.getItem('client_id')
      localStorage.removeItem('client_id')
    }
  },
  methods: {
    store() {
      this.form.post(this.route('notes.store'))
      // this.$inertia.visit(`/admin/clients/${this.form.client_id}/edit`)
    },
  },
}
</script>

